const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export function formatCentsUSD(cents) {
  const n = Number(cents || 0)
  if (!Number.isFinite(n)) return usdFormatter.format(0)
  return usdFormatter.format(n / 100)
}

